module.exports = __webpack_public_path__ + "static/media/pg_drag_n_match_overlay_1.440b22f1.svg";